import React from 'react'

import url from 'libraries/front-end-core/core/url'
import { pushUrl } from 'libraries/front-end-core/core/history'
import { useDispatch, useSelector } from 'react-redux'

import { FiltersHeader } from 'components/search/Facets'
import { SEARCH } from 'constants/controllers'

import selectSearchQuery from 'redux/selectors/selectSearchQuery'
import { setSearchState } from 'redux/actions'
import FacetOption from './FacetOption'

const parameterName = 'automated'

const PrecedentsSearchFilters = ({
  searchType,
  paginationMode,
  searchPhrase,
  facets = [],
  aol,
  flavour,
  pageNumber
}) => {
  const _query = useSelector(selectSearchQuery)

  const isSelected = (optionName) => {
    const isFiltered = Object.prototype.hasOwnProperty.call(_query, parameterName)
    if (!isFiltered) {
      return false
    }
    const automated = _query[parameterName]
    if (optionName === 'Automated' && automated === 'true') {
      return true
    } else if (optionName === 'Static' && automated === 'false') {
      return true
    } else {
      return false
    }
  }

  const dispatch = useDispatch()

  const setSearch = (query) => {
    const paginationMode = pageNumber > 0 ? 'paged' : 'all'
    const _pageNumber = paginationMode !== 'paged'

    dispatch(setSearchState({ pageNumber: _pageNumber, query }))
    pushUrl(url(
      SEARCH,
      { aol, searchPhrase, searchType, pageNumber: _pageNumber },
      query
    ))
  }

  const handleFacetOptionClick = (parameterName, value, selected) => {
    if (setSearchState) {
      const query = { ..._query }
      query[parameterName] = `${value && selected}`
      if (!selected) {
        delete query[parameterName]
      }
      setSearch(query)
    }
  }

  return (
    <div className='mt6 mb4 pa5 bg-white'>
      <FiltersHeader {...{ flavour, searchType, searchPhrase, aol }} />
      {facets.map((facet) =>
        <FacetOption
          key={facet.name}
          {...{
            parameterName,
            name: `${facet.name} (${facet.docCount})`,
            value: facet.name === 'Automated',
            selected: isSelected(facet.name),
            handleFacetOptionClick
          }}
        />
      )}
    </div>
  )
}

export default PrecedentsSearchFilters
